import React from 'react';
export function ProductSection() {
  return <section className="py-6 md:py-9 px-5 bg-[radial-gradient(ellipse_at_top,rgba(107,0,182,0.2)_0%,transparent_60%),var(--dark-bg)]" data-id="element-200" data-mp="1hytvpf5ypuxg">
      <div className="max-w-[900px] mx-auto" data-id="element-201" data-mp="hj07sksc3idl">
        <span className="inline-block font-heading font-bold text-[0.75rem] tracking-[3px] uppercase text-magenta-bright mb-2" data-id="element-202" data-mp="hkuspz3lvaho">
          El método
        </span>

        <h2 className="text-[clamp(1.6rem,4vw,2.5rem)] font-heading font-black leading-[1.15] mb-3" data-id="element-203" data-mp="qjf40f6u6hvv">
          La colección que
          <br data-id="element-204" data-mp="mhl8smfeu633" />
          <span className="text-gradient-magenta" data-id="element-205" data-mp="mi3dm7g51smm">va a la raíz</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-[1fr_1.2fr] gap-5 md:gap-8 items-center mt-4" data-id="element-206" data-mp="10gtcnsmiq2dm">
          <div className="w-full" data-id="element-207" data-mp="vkcjgk0goxto">
            <img src="https://cdn.magicpatterns.com/uploads/pJZQQ1y91fqaN7VirMLzzV/oDiXxM0087776.webp" alt="Colección Placer, Culpa y Vacío — 4 volúmenes" className="w-full rounded-2xl drop-shadow-[0_20px_50px_rgba(194,0,111,0.4)]" data-id="element-208" data-mp="vh8dbh3frs0d" />
          </div>

          <div data-id="element-209" data-mp="1b7796yp8g0g">
            <h3 className="text-[clamp(1.5rem,3vw,2.2rem)] font-heading font-black mb-[10px] bg-clip-text text-transparent bg-gradient-to-br from-white to-off-white" data-id="element-210" data-mp="1axpu7rpzh6d">
              PLACER, CULPA Y VACÍO
            </h3>
            <p className="text-[0.9rem] text-magenta-bright font-heading font-semibold mb-5" data-id="element-211" data-mp="a4j7byv9rcjh"></p>

            <div className="flex gap-2 my-3 flex-wrap" data-id="element-212" data-mp="f3dqj1x5f344">
              <span className="bg-gradient-to-br from-purple-mid to-magenta py-2 px-[18px] rounded-full font-heading font-bold text-[0.85rem]" data-id="element-213" data-mp="f4yg0d4lvvv4">
                📘 Volumen 1
              </span>
              <span className="bg-gradient-to-br from-purple-mid to-magenta py-2 px-[18px] rounded-full font-heading font-bold text-[0.85rem]" data-id="element-214" data-mp="oyxijd8ldhnl">
                📗 Volumen 2
              </span>
              <span className="bg-gradient-to-br from-purple-mid to-magenta py-2 px-[18px] rounded-full font-heading font-bold text-[0.85rem]" data-id="element-215" data-mp="2qu7xzzj2n8rx">
                📙 Volumen 3
              </span>
              <span className="bg-gradient-to-br from-purple-mid to-magenta py-2 px-[18px] rounded-full font-heading font-bold text-[0.85rem]" data-id="element-216" data-mp="21cfo2ciofy1">
                📕 Volumen 4
              </span>
            </div>

            <div className="text-[0.95rem] leading-[1.6] text-white/80 space-y-2" data-id="element-217" data-mp="axlg9kc8dklr">
              <p data-id="element-218" data-mp="70flhp0bmq72">
                Una colección de 4 volúmenes diseñada como sistema progresivo:
                cada uno profundiza en un punto del ciclo P-C-V y te da las
                herramientas específicas para trabajarlo.
              </p>
              <p data-id="element-219" data-mp="uo6x0qe1ez7a">
                No es un libro para leer y guardar. Es un sistema para{' '}
                <strong data-id="element-220" data-mp="poaukvkznftu">hacer</strong> — con prácticas de 5 a 15 minutos diarios
                que no requieren que nadie más lo sepa.
              </p>
              <p data-id="element-221" data-mp="13miwlhwvt7bv">
                Empiezas desde donde estás.{' '}
                <strong className="text-magenta-bright" data-id="element-222" data-mp="yqk5hmk65b7r">Hoy.</strong>
              </p>
            </div>

            <div className="mt-4 p-4 rounded-2xl bg-gradient-to-br from-[rgba(194,0,111,0.1)] to-[rgba(107,0,182,0.1)] border border-magenta-bright/30" data-id="element-223" data-mp="1iclw4lcbrhmj">
              <p className="font-heading font-black text-[1.05rem] text-gold mb-0.5 uppercase tracking-[1px]" data-id="element-224" data-mp="19amcrmdu81gf">
                🎁 Vienen de regalo 3 bonos
              </p>
              <p className="text-[0.85rem] text-magenta-bright font-heading font-bold mb-2.5" data-id="element-225" data-mp="1deao8g5lbh6y">
                Hoy con la compra — <span className="uppercase" data-id="element-226" data-mp="14bj8w59lg1a1">GRATIS</span>
              </p>

              <div className="space-y-2.5" data-id="element-227" data-mp="14cud266ybb1o">
                <div className="flex items-start gap-4 bg-[rgba(107,0,182,0.12)] rounded-xl p-3 border border-white/5" data-id="element-228" data-mp="pn57zzvqmmw4">
                  <img src="https://cdn.magicpatterns.com/uploads/nMZ13FC2JgavAGyiiGzKCh/unnamed_(4).png" alt="Plan de 30 días: de los vicios a la disciplina" className="w-[80px] rounded-lg shrink-0 drop-shadow-[0_4px_12px_rgba(0,0,0,0.4)]" data-id="element-229" data-mp="umrkg73qrz3v" />
                  <div data-id="element-230" data-mp="dju9vnbhvfyl">
                    <span className="inline-block bg-gradient-to-br from-purple-mid to-magenta text-white font-heading font-black text-[0.7rem] tracking-[1px] uppercase py-0.5 px-2 rounded mb-1.5" data-id="element-231" data-mp="dm6njoa7z45u">
                      BONO 1
                    </span>
                    <p className="font-heading font-bold text-white text-[0.95rem] leading-tight" data-id="element-232" data-mp="3vxa8symc314d">
                      Plan de 30 días: de los vicios a la disciplina
                    </p>
                    <p className="text-white/50 text-[0.8rem] leading-relaxed mt-1" data-id="element-233" data-mp="3lz45cckvpmxe">
                      Guía paso a paso con ejercicios diarios para reemplazar
                      hábitos destructivos por rutinas que fortalecen tu
                      disciplina.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4 bg-[rgba(107,0,182,0.12)] rounded-xl p-3 border border-white/5" data-id="element-234" data-mp="1f7li4xyj74vx">
                  <img src="https://cdn.magicpatterns.com/uploads/aBaUcJ67RpJSyimUaQ9Px4/unnamed_(3).png" alt="Entender la dopamina y el cerebro adictivo" className="w-[80px] rounded-lg shrink-0 drop-shadow-[0_4px_12px_rgba(0,0,0,0.4)]" data-id="element-235" data-mp="2t5qwdinqnjcy" />
                  <div data-id="element-236" data-mp="36xnk7aidj73j">
                    <span className="inline-block bg-gradient-to-br from-purple-mid to-magenta text-white font-heading font-black text-[0.7rem] tracking-[1px] uppercase py-0.5 px-2 rounded mb-1.5" data-id="element-237" data-mp="36w2q1lzz1q67">
                      BONO 2
                    </span>
                    <p className="font-heading font-bold text-white text-[0.95rem] leading-tight" data-id="element-238" data-mp="2j7jhd5d0fbdl">
                      Entender la dopamina y el cerebro adictivo
                    </p>
                    <p className="text-white/50 text-[0.8rem] leading-relaxed mt-1" data-id="element-239" data-mp="2o49vvo961yww">
                      Aprende cómo funciona el sistema de recompensa de tu
                      cerebro y por qué caes en patrones repetitivos.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4 bg-[rgba(107,0,182,0.12)] rounded-xl p-3 border border-white/5" data-id="element-240" data-mp="1zlehfsdewtqm">
                  <img src="https://cdn.magicpatterns.com/uploads/renZEirDDVqjtt9rixQ7AY/unnamed_(2).png" alt="Cómo manejar una recaída sin destruir tu proceso" className="w-[80px] rounded-lg shrink-0 drop-shadow-[0_4px_12px_rgba(0,0,0,0.4)]" data-id="element-241" data-mp="29hhisw0fwoci" />
                  <div data-id="element-242" data-mp="1buqxg8q82dnp">
                    <span className="inline-block bg-gradient-to-br from-purple-mid to-magenta text-white font-heading font-black text-[0.7rem] tracking-[1px] uppercase py-0.5 px-2 rounded mb-1.5" data-id="element-243" data-mp="1bvk4zbx0976w">
                      BONO 3
                    </span>
                    <p className="font-heading font-bold text-white text-[0.95rem] leading-tight" data-id="element-244" data-mp="y2b11qrttdvr">
                      Cómo manejar una recaída sin destruir tu proceso
                    </p>
                    <p className="text-white/50 text-[0.8rem] leading-relaxed mt-1" data-id="element-245" data-mp="34r39gqq2zw4t">
                      Estrategias concretas para que un tropiezo no se convierta
                      en una caída libre y puedas retomar tu camino.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}